import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';
import { MainChartDetails } from '#/modules/salaries/components/MainChartDetails/MainChartDetails';
import type { MainChartData } from '#/modules/salaries/types/MainChartData';

import { FooterContainer, FooterLink } from './MainChartFooter.styled';

type Props = {
  data: MainChartData;
  initialized: boolean;
  loading: boolean;
};

export function MainChartFooter({ data, initialized, loading }: Props) {
  const { i18n } = useI18n();

  return (
    <FooterContainer $initialized={initialized} $loading={loading}>
      {!initialized || (!loading && data === null) || loading ? (
        <BodySmall textAlign="center">
          <FooterLink href={i18n('/survey/faq')}>
            {i18n('See our FAQ for more information on our data')}
          </FooterLink>
        </BodySmall>
      ) : (
        <MainChartDetails data={data} />
      )}
    </FooterContainer>
  );
}
